/* src/app/layout/footer/footer.component.scss */
/*# sourceMappingURL=footer.component-JNRW4PBK.css.map */
